module.exports = __webpack_public_path__ + "img/favicon-reverse.ab28e874.png";